module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "is-margin-top-0"
  }, [_vm._v(_vm._s(_vm.$t('ui.lead_mask_editor.basic_config')))]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('form', {
    staticClass: "lead-mask-update--form max-width",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('div', {
    staticClass: "has-gutter-l"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "name",
      "placeholder": "Lead Sheet Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "language",
      "type": "select",
      "placeholder": "English",
      "collection": _vm.selectableLanguages
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "alwaysHidden"
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organization.list'),
      expression: "'organization.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "organization",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    staticClass: "lead-mask-raw"
  }, [_c('div', {
    staticClass: "lead-mask-raw--title",
    on: {
      "click": function($event) {
        _vm.isRawDisplayed = !_vm.isRawDisplayed
      }
    }
  }, [(_vm.isRawDisplayed) ? _c('i', {
    staticClass: "icon yule-icon-chevron-down"
  }) : _c('i', {
    staticClass: "icon yule-icon-chevron-right"
  }), _vm._v("\n      " + _vm._s(_vm.$t('ui.lead_mask_editor.see_raw')) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRawDisplayed),
      expression: "isRawDisplayed"
    }],
    staticClass: "lead-mask-raw--content"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "structure",
      "type": "textarea",
      "value": _vm.structure,
      "placeholder": "{json}"
    },
    on: {
      "input": _vm.structureChange
    }
  })], 1)]), _vm._v(" "), _c('page-saver', {
    staticClass: "page-saver-wrapper",
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f37c1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/lead_masks/LeadMaskOptions.vue
// module id = 1796
// module chunks = 0